import * as React from "react";
import { cn } from "../../lib/utils";

/**
 * Small labeled value tile (SideBar profile meta, etc.).
 */
function InfoTile({ label, value, className }) {
  return (
    <div
      className={cn(
        "rounded-card border border-slate-200/90 bg-white/[0.78] px-2.5 py-2.5",
        className,
      )}
    >
      <span className="mb-1 block text-xs font-bold text-slate-400">
        {label}
      </span>
      <strong className="block break-words text-sm font-extrabold text-slate-700">
        {value}
      </strong>
    </div>
  );
}

export { InfoTile };
